import { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';

import { AuthContextType } from '@/components/auth-provider';
import { TanStackRouterDevtools } from '@/components/tan-stack-router-devtools';

const RouteComponent = () => {
  return (
    <>
      <Outlet />

      <TanStackRouterDevtools position="bottom-right" initialIsOpen={false} />
    </>
  );
};

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
  auth: AuthContextType;
}>()({
  component: RouteComponent,
  errorComponent: () => {
    return (
      <>
        <Outlet />
      </>
    );
  },
  loader: () => ({ crumb: 'home' }),
});
